import { Anchor, type _Navigation } from ":shared/components/route";
import { default as routes } from "../routes";
import IdleIcon from "../assets/icons/idle-setting.svg";
import ActiveIcon from "../assets/icons/active-setting.svg";
export default function Profile(props: _Navigation.SideNavJSXItemProps) {
  return (
    <Anchor
      class={props.anchor?.class}
      setup={{
        to: routes,
        classes: {
          active: `${props.anchor.setup.classes.active}`,
        },
      }}
      options={{
        activeOnBase: true,
      }}
      components={{
        title: "Profile Settings",
        idleIcon: <IdleIcon />,
        activeIcon: <ActiveIcon />,
      }}
    />
  );
}
